import IConfig from '../State/Stores/Config/Interfaces/IConfig';

import PlayerFacade from './PlayerFacade';

/**
 * A factory function forming a simplified, primary consumer entry
 * point into the player library.
 */

const playerFactory = (wrapper: HTMLElement, options: IConfig = {}): PlayerFacade => {
    if (!(wrapper instanceof HTMLElement)) {
        throw new TypeError('No valid parent element provided');
    }

    const player = new PlayerFacade(wrapper, options);

    return player;
};

export default playerFactory;